import rules from '@anchor/vue-assets/src/plugins/form-rules';

const anchor11 = val => !val.toLowerCase().includes('anchor11') || '"Anchor11" is not allowed within passwords';
const atLeastOneNumber = val => /(?=.*[0-9]{1,})/gi.test(val) || 'At least one number is required';
const atLeastOneLetter = val => /(?=.*[a-zA-Z]{1,})/gi.test(val) || 'At least one letter is required';
const atLeastOneSpecial = val => /(?=.*[\W_]{1,})/gi.test(val) || 'At least one special character is required';

export default {
  current_password: [
    rules.required,
  ],
  new_password: [
    rules.required,
    rules.min(8),
    anchor11,
    atLeastOneNumber,
    atLeastOneLetter,
    atLeastOneSpecial,
  ],
  confirm_new_password: [
    rules.required,
    rules.min(8),
  ],
};
